/**
 * Nota aos desenvolvedores:
 *
 * Este componente faz uso do Composition Pattern.
 * Um pattern de composição que auxilia em componentes com múltiplas customizações;
 *
 * @Usage
 *
 * O `PersonForm` está dividido em componentes semânticos reutilizáveis:
 *
 * - PersonForm.Root: Componente raiz responsável pelo `<Form>` e manipulação do `onSubmit`;
 * - PersonForm.Input: Campo de input genérico com validação integrada ao Formik;
 * - PersonForm.Select: Campo de select com validação integrada ao Formik;
 * - PersonForm.AddressFields: Bloco de campos de endereço (CEP, Logradouro, Número, etc...);
 * - PersonForm.Actions: Container que envolve os botões de ação (ex: Cancelar, Salvar).
 *
 * @example
 * <PersonForm.Root onSubmit={formik.handleSubmit}>
 *   <Card>
 *     <CardBody>
 *       <Row className="g-3">
 *         <PersonForm.Input
 *           name="name"
 *           label="Nome"
 *           validation={formik}
 *         />
 *
 *         <PersonForm.Select
 *           name="gender"
 *           label="Sexo"
 *           options={genderOptions}
 *           validation={formik}
 *         />
 *
 *         <PersonForm.AddressFields validation={formik} />
 *       </Row>
 *     </CardBody>
 *
 *     <CardFooter>
 *       <PersonForm.Actions>
 *         <MainButton type="submit">Salvar</MainButton>
 *       </PersonForm.Actions>
 *     </CardFooter>
 *   </Card>
 * </PersonForm.Root>
 */

import { PersonFormActions } from './person-form-actions';
import { PersonFormAddressFields } from './person-form-address-fields';
import { PersonFormInput } from './person-form-input';
import { PersonFormRoot } from './person-form-root';
import { PersonFormSelect } from './person-form-select';

export const PersonForm = {
  Root: PersonFormRoot,
  Input: PersonFormInput,
  Select: PersonFormSelect,
  Actions: PersonFormActions,
  AddressFields: PersonFormAddressFields,
};
